import { render, staticRenderFns } from "./ServiceSummaryItem.vue?vue&type=template&id=1554d340&scoped=true&"
import script from "./ServiceSummaryItem.vue?vue&type=script&lang=ts&"
export * from "./ServiceSummaryItem.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceSummaryItem.vue?vue&type=style&index=0&id=1554d340&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1554d340",
  null
  
)

export default component.exports